import { getSessionDuration } from 'application/session_duration'

export function pushEventToGTMDataLayer(data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({...data, session_duration: getSessionDuration() })
}
